/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import forEach from 'lodash/forEach';
import Picture from '../../../ui/Picture';
import { Breakpoints } from '../../../../styles/Grid/GridSizes';
import { Container, Row, Column } from '../../../../styles/Grid';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles.js';

const contactImageSize = {
  ...CLOUDINARY_BASE_VALUES,
  aspectRatio: '1:1',
  height: 48,
  width: 48,
};

const contactImageSizes = {
  [Breakpoints.sm]: contactImageSize,
  [Breakpoints.md]: contactImageSize,
  [Breakpoints.lg]: contactImageSize,
  [Breakpoints.xl]: contactImageSize,
};

const emptyValue = {
  value: '',
};

const defaultData = {
  availableLocation: 0,
  ContactIcon: emptyValue,
  ContactPhrase: emptyValue,
  CountryPhone: emptyValue,
  Headline: emptyValue,
  Subtitle: emptyValue,
  totalLocation: 0,
};

class Hero extends SafePureComponent {
  /**
   * Replaces the given values in a string. Values to be replace must be
   * wrapped in curly braces
   * @param {string} str string to be modified
   * @param {object} values to be replaced in the string
   * @return {string} updated string
   */
  replaceLocationCount(str, values) {
    forEach(values, function (value, key) {
      const regex = new RegExp(`{${key}}`, 'gi');
      str = str.replace(regex, value);
    });

    return str;
  }

  safeRender() {
    const {
      availableLocation,
      ContactIcon,
      ContactPhrase,
      CountryPhone,
      Headline,
      Subtitle,
      totalLocation,
    } = this.props;

    const subtitle = this.replaceLocationCount(Subtitle.value, {
      availableLocation,
      totalLocation,
    });

    return (
      <header css={styles.hero}>
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 7, lg: 8, xl: 7 }}>
              <h1 css={styles.headline}>
                <Text field={Headline} />
              </h1>
            </Column>
          </Row>
          <Row css={styles.subHeadline}>
            <Column cols={{ sm: 6, md: 7, lg: 8, xl: 7 }}>
              <p css={styles.subHeadlineCopy}>{subtitle}</p>
            </Column>
            <Column
              cols={{ sm: 6, md: 8, lg: 4, xl: 5 }}
              css={styles.contactInformation}
            >
              <div css={styles.contactInformationThumbnailWrapper}>
                <Picture
                  image={ContactIcon}
                  imageCss={styles.contactInformationThumbnail}
                  imageSizes={contactImageSizes}
                  instantLoad
                />
              </div>
              <div css={styles.contactInformationContactInfo}>
                <h4 css={styles.contactInformationCopy}>
                  <Text field={ContactPhrase} />
                </h4>
                <a
                  href={`tel: ${CountryPhone}`}
                  css={styles.contactInformationNumber}
                >
                  <Text field={CountryPhone} />
                </a>
              </div>
            </Column>
          </Row>
        </Container>
      </header>
    );
  }
}

const objectValueType = {
  value: PropTypes.string,
};

Hero.displayName = 'Hero';

Hero.defaultProps = {
  ...defaultData,
};

Hero.propTypes = {
  availableLocation: PropTypes.number,
  ContactIcon: PropTypes.shape({
    src: PropTypes.string,
  }),
  ContactPhrase: PropTypes.shape(objectValueType),
  CountryPhone: PropTypes.shape(objectValueType),
  Headline: PropTypes.shape(objectValueType),
  Subtitle: PropTypes.shape(objectValueType),
  totalLocation: PropTypes.number,
};

export default Hero;
